import FormHelperText from '@mui/material/FormHelperText';
import OutlinedInput from '@mui/material/OutlinedInput';
import React from 'react';
import { inputStyle } from '../../utils/formStyle';
import { FormInputLabel } from './FormInputLabel';

export const FormInput = React.forwardRef((props, ref) => {
  const { label, error, ...rest } = props;
  return (
    <div className='flex flex-col gap-1 flex-grow'>
      {label && <FormInputLabel label={label} isRequired={rest.required} />}
      <OutlinedInput sx={inputStyle} inputProps={rest.inputProps} {...rest} inputRef={ref} error={!!error} />
      {error && <FormHelperText error>{error.message}</FormHelperText>}
    </div>
  );
});

FormInput.displayName = 'FormInput';
